import React from "react";
import "./ImageUpload.css";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";

const ImageUpload = () => {
  return (
    <div className="text-white text-center">
      <h3 className="">Profile Image Setting</h3>
      <div>
        <div className="file-input mt-5">
          <input type="file" id="file" className="file" />
          <label for="file">
            <p className="text-center" >
              <PermIdentityOutlinedIcon />
           
            <br />
           
              Drop your file here or &nbsp; <span className="cl-pm">Browse</span> <br/> <span style={{ color: "#AFAFAF" }}>Supported: JPG,JPEG,PNG</span>
            </p>
           
          </label>
        </div>
        <button type="button" className="contact-button">
          Save
        </button>
      </div>
    </div>
  );
};

export default ImageUpload;
